module.exports = __webpack_public_path__ + "static/media/logo.bd6fef60.png";